import { FC } from "react";
import { attractionsData } from "../configs"
import { AttractionLink } from "./AttractionLink";
import { AttractionsList } from "./AttractionsList";

export const AttractionsLinks: FC = () => {
  return (
    <>
      <h2 className="text-3xl md:text-4xl font-bold text-red-500 mx-6 mt-6 md:mt-10 mb-6">{attractionsData.attractionsLinks.title}</h2>
      <AttractionsList> 
        {attractionsData.attractionsLinks.linksToDetails.map((attraction, index) => (
          <div key={index}>
            <AttractionLink attraction={attraction} />
          </div>
        ))}
      </AttractionsList>
    </>
  );
}